import { render, staticRenderFns } from "./Placepage.vue?vue&type=template&id=4c297784&scoped=true&"
import script from "./Placepage.vue?vue&type=script&lang=js&"
export * from "./Placepage.vue?vue&type=script&lang=js&"
import style0 from "./Placepage.vue?vue&type=style&index=0&id=4c297784&prod&lang=scss&"
import style1 from "./Placepage.vue?vue&type=style&index=1&id=4c297784&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c297784",
  null
  
)

export default component.exports